import React from 'react';

import { DOCUSIGN } from '../../../../theme/tokens';
import { DOCUSIGN_LOGO_VIEWBOX, DOCUSIGN_MARK, DOCUSIGN_WORDMARK } from './docusign-logo';
import { Root } from './DocusignLogo.styles';

export type DocusignLogoProps = {
  /** The accessible name. Omitted: the logo is decorative (`aria-hidden`), e.g. inside a picture that is. */
  label?: string;
  className?: string;
};

/**
 * DocuSign's official logo (see `docusign-logo.ts`), one `1em` tall: the parent's font size sets it.
 * The mark keeps its brand fills; the wordmark and the mark's middle piece take `currentColor`, so
 * the logo reads on dark and light alike.
 */
export const DocusignLogo = ({ label, className }: DocusignLogoProps): React.ReactElement => (
  <Root
    className={className}
    viewBox={DOCUSIGN_LOGO_VIEWBOX}
    role={label ? 'img' : undefined}
    aria-label={label}
    aria-hidden={label ? undefined : true}
    focusable="false"
  >
    {DOCUSIGN_WORDMARK.map((d) => (
      <path key={d} d={d} fill="currentColor" />
    ))}
    <path d={DOCUSIGN_MARK.cobalt} fill={DOCUSIGN.cobalt} />
    <path d={DOCUSIGN_MARK.poppy} fill={DOCUSIGN.poppy} />
    <path d={DOCUSIGN_MARK.overlap} fill="currentColor" />
  </Root>
);

export default DocusignLogo;
